var vms = vms || {};
vms.doc = vms.doc || {};

vms.doc.setStatus = function (pID, pStatus, pSyncDirection, pProfileID) {
    apex.server.process("documentStatus", {
        x01: pID,
        x02: pStatus,
        x03: pSyncDirection,
        x04: pProfileID
    }, {
            dataType: "text",
            success: function (pData) {
                location.reload();
            }
        });
}